import { observer } from 'mobx-react-lite'
import React, { Fragment, useContext, useMemo, useState } from 'react'
import { Instagram, Tiktok, Youtube, Linkedin, Pinterest, Headphones, Stars } from 'react-bootstrap-icons'
import { currencyFormat, separateThousands } from '../../../../../../../utils/Helper'
import DropdownButton from '../../../../../../FormComponents/DropdownButton'
import MediaActions from './MediaActions'
import { SharedCampaignContext } from '../../../../../../../contexts/Advertiser/SharedCampaignContext'

export default observer(function MediaScenarioActionGroup({ actionGroup, campaignScenario }) {
  const { campaign } = useContext(SharedCampaignContext)
  const [dropdownOpen, setDropdownOpen] = useState(true)

  const actions = useMemo(() => campaignScenario.actions.filter(action => action.campaign_scenario_action_group_id === actionGroup.id), [campaignScenario.actions, campaignScenario.actions.length])

  const advertiserPrice = useMemo(() => actions.reduce((result, action) => result + action.totalAdvertiserPrice, 0))
  const totalImpression = useMemo(() => actions.reduce((result, action) => result + action.impression, 0))
  const grossReach = useMemo(() => actions.reduce((result, action) => result + action.reach, 0), [actions, actions.length])
  const buyoutPrice = useMemo(() => actions.reduce((result, action) => result + action.buyoutPrice, 0))

  const name = useMemo(() => ({
    instagram_reel: 'Instagram Reel',
    instagram_story: 'Instagram Story',
    instagram_post: 'Instagram Post',
    instagram_carousel_post: 'Instagram Carousel Post',
    tiktok_video: 'TikTok Video',
    youtube_video: 'YouTube Video',
    youtube_short: 'YouTube Shorts',
    linkedin_post: 'LinkedIn Beitrag',
    linkedin_video: 'LinkedIn Video',
    linkedin_newsletter: 'LinkedIn Newsletter',
    pinterest_pin: 'Pinterest Pin',
    podcast_episode: 'Podcast Episode',
    other_item: 'Other Collaboration',
  }[actionGroup.action_type]), [actionGroup.action_type])
  const displayName = useMemo(() => name?.split(' ').slice(1).join(' ') || 'Unknown', [name])

  const icon = useMemo(() => ({
    instagram_reel: <Instagram className="text-pink-600" />,
    instagram_story: <Instagram className="text-pink-600" />,
    instagram_post: <Instagram className="text-pink-600" />,
    instagram_carousel_post: <Instagram className="text-pink-600" />,
    tiktok_video: <Tiktok />,
    youtube_video: <Youtube className="text-red-500" />,
    youtube_short: <Youtube className="text-red-500" />,
    linkedin_post: <Linkedin className="text-rb-linkedin" />,
    linkedin_video: <Linkedin className="text-rb-linkedin" />,
    linkedin_newsletter: <Linkedin className="text-rb-linkedin" />,
    pinterest_pin: <Pinterest className="text-red-700" />,
    podcast_episode: <Headphones />,
    other_item: <Stars className="text-amber-600" />,
  }[actionGroup.action_type]), [actionGroup.action_type])

  return (
    <Fragment>
      <div className={`grid grid-cols-8 ${dropdownOpen && 'border-b-2 border-border-primary dark:border-rb-dark-mode-lighter'}`}>
        <div className="flex items-center justify-between col-span-2 p-2 border-r-2 border-border-primary dark:border-rb-dark-mode-lighter col-span-4">
          <div className="flex items-center">
            {icon}
            <p className="ml-2 font-bold dark:text-white">{displayName}</p>
          </div>
          <div className="flex items-center">
            <DropdownButton dropdownOpen={dropdownOpen} setDropdownOpen={setDropdownOpen} className="dark:text-white" />
          </div>
        </div>
        <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
          <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Total Impression</p>
          <p className="font-bold text-sm dark:text-white">{separateThousands(totalImpression)}</p>
        </div>
        <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
          <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Gross Reach</p>
          <p className="font-bold text-sm dark:text-white">{separateThousands(grossReach)}</p>
        </div>
        <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
          <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Price</p>
          <p className="font-bold text-sm dark:text-white">{currencyFormat(advertiserPrice.toFixed(2), campaign.currency_symbol)}</p>
        </div>
        <div className="p-2">
          <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Buyouts</p>
          <p className="font-bold text-sm dark:text-white">{currencyFormat(buyoutPrice.toFixed(2), campaign.currency_symbol)}</p>
        </div>
      </div>
      { dropdownOpen && <MediaActions actions={actions} campaignScenario={campaignScenario} actionGroup={actionGroup} />}
    </Fragment>
  )
})